import { PageHeader } from '@my/ui';
import { useTranslation } from 'react-i18next';

/**
 * Placeholder landing page for the Safety skeleton. Replace with a real
 * dashboard once Safety features land. Kept deliberately minimal — it only
 * proves the authenticated shell + routing + localisation render end-to-end.
 */
export function HomePage() {
  const { t } = useTranslation('dashboard');

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      <PageHeader title={t('title')} description={t('subtitle')} />
      <section className="mt-6 rounded-lg border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm">
        <p className="text-sm text-slate-500">{t('placeholder')}</p>
      </section>
    </div>
  );
}
